import { NgClass, NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { OutcomeType } from '@cds/betting-offer/add-ons';

@Component({
    selector: 'ms-form-indicator',
    templateUrl: './form-indicator.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgFor, NgClass],
})
export class FormIndicatorComponent {
    @Input() outcomes: OutcomeType[];

    @HostBinding('class') className = 'form-indicators';
}
